<app-billing-information-active (licenceChanged)="licenceChanged.emit()"></app-billing-information-active>
<app-billing-edit-license (licenceChanged)="licenceChanged.emit()"></app-billing-edit-license>
<ng-container *ngIf="activeWp && !activeWp.dateTimeInactive">
  <app-billing-resign-license></app-billing-resign-license
></ng-container>
<app-billing-history></app-billing-history>
